import { useEffect, useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { auth, db } from '../Firebase_Config/firebase';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { NavLink } from "react-router-dom";
import './FederatedLearning.css';
//https://web3forms.com/


const GET_EMAIL = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState('success');
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userDocQuery = query(collection(db, 'users'), where('userId', '==', user.uid));
      const userDocSnapshot = await getDocs(userDocQuery);

      if (!userDocSnapshot.empty) {
        const userData = userDocSnapshot.docs[0].data();
        setFormData(prev => ({
          ...prev,
          name: userData.Name || '',
          email: userData.email || ''
        }));
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, message: e.target.value });
  };

  const showToast = (message, severity = 'success') => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const handleCloseToast = (_, reason) => {
    if (reason === 'clickaway') return;
    setToastOpen(false);
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const formDataToSend = {
      ...formData,
      access_key: "eeb7e415-06eb-495c-a9f8-075545b91e36"
    };

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(formDataToSend)
    }).then((res) => res.json());

    if (res.success) {
      showToast("Email submitted successfully!", "success");
      setFormData(prev => ({ ...prev, message: '' }));
    } else {
      showToast("Failed to submit. Please try again.", "error");
    }
  };

  return (
    <div className="ContactContainer">
      <h1 className='helptitle'>Contact Form</h1>
      <br/>
      <div className='Hom-card-accent'/>
      
      <form onSubmit={onSubmit}>
        <textarea
          className='OtherInputs'
          name="message"
          placeholder="Write Your Message Here.."
          value={formData.message}
          onChange={handleChange}
        />
        <button className='SubmitInput' type="submit">Submit Form</button>
      </form>

      <Snackbar open={toastOpen} autoHideDuration={4000} onClose={handleCloseToast} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <MuiAlert onClose={handleCloseToast} severity={toastSeverity} sx={{ width: '100%' }} elevation={6} variant="filled">
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};



const FederatedLearning = () => {
  const [showModal, setShowModal] = useState(true);
    const [hasPaidTrue, setHasPaidTrue] = useState(null);
    const [showContactModal, setShowContactModal] = useState(false);
  
    const getUserId = () => {
      const user = auth.currentUser;
      return user?.uid;
    };
  
    const fetchHasPaidTrue = async () => {
      try {
        const userId = getUserId();
        if (!userId) return;
  
        const userDocQuery = query(collection(db, 'users'), where('userId', '==', userId));
        const userDocSnapshot = await getDocs(userDocQuery);
  
        if (!userDocSnapshot.empty) {
          const userDocData = userDocSnapshot.docs[0].data();
          const getHasPaid = userDocData.HasPaid || false;
          setHasPaidTrue(getHasPaid);
        } else {
          console.log('User document not found');
          setHasPaidTrue(false); // default to false if not found
        }
      } catch (error) {
        console.error('Error fetching payment status:', error);
        setHasPaidTrue(false);
      }
    };
  
    useEffect(() => {
      fetchHasPaidTrue();
    });
  
    const isDisabled = hasPaidTrue === false;
    const handleContactClick = () => {
      setShowModal(false);
      setShowContactModal(true);
    };
  return (
    <div className='fedBG'>
      {hasPaidTrue === false && showModal && (
        <div className="Ai-modal-overlay">
          <div className="paid-modal-content">
            <button className="close-button" onClick={() => setShowModal(false)}>×</button>
             <button className="contact-button" onClick={handleContactClick}>Contact Us To Get Access</button>
          </div>
        </div>
      )}

      {showContactModal && (
        <div className="Ai-modal-overlay">
          <div className="paid-modal-content contact">
            <button className="close-button" onClick={() => setShowContactModal(false)}>×</button>
            <GET_EMAIL />
          </div>
        </div>
      )}
      <div className='FedMainContent'>
        <div className='Fed-container'>
          <div className='Fed-card-accent'/>
          <br/>
          <img src="NexusFL.png" alt="Logo" className='Fed-image' />
          <div className='textContent'>
            {/*<h2 className='headingcenter'>The hub for Collaborative Learning, Zero Data Sharing</h2>
            <p className='textCenter'>A suite of tools for a customised, end-to-end responsible AI experience</p>*/}
            <div className='FedContainer'>
              <div className='Fed2'>
                <div className='Fedcolumns'>
                  <h2>What is Federated Learning?</h2>
                  <p>Federated Learning (FL) is a decentralized machine learning approach that enables multiple devices or organizations to collaboratively train an AI model without sharing raw data. Instead of centralizing datasets in one location, FL allows models to be trained locally on distributed devices (e.g., smartphones, edge servers, or hospitals), with only model updates (gradients) being aggregated to improve a global model. This preserves data privacy by design, as sensitive information never leaves its original source. NexusFL is a toolkit that streamlines this process, providing secure aggregation, communication protocols, and differential privacy tools to make federated learning scalable and production-ready.</p>
                </div>
                <div className='Fedcolumns'>
                  <h2>Benefits of Federated Learning with NexusFL:</h2>
                  <p>NexusFL empowers organizations to harness the power of collective intelligence while maintaining strict data privacy and compliance. By eliminating the need to pool raw data, it reduces risks of breaches, ensures compliance with regulations like GDPR or HIPAA, and enables collaboration across siloed or competitive environments (e.g., healthcare, finance). The toolkit optimizes performance with features like adaptive model synchronization, resource-efficient training, and bias mitigation across distributed datasets. With NexusFL, businesses can build robust, privacy-preserving AI systems faster—unlocking insights from fragmented data without compromising security or ownership.</p>
                </div>
              </div>
              <div className='button-group'>
                <NavLink 
                  to="/ContactUs" 
                >
                  <button className='download-button' >Contact Us</button>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FederatedLearning;
